import styled from 'styled-components';

import ProductResolutionImage from 'ggApp/shared/components/resolutionImage/ProductResolutionImage';
import ShimmerEffect from 'ggApp/shared/components/shimmerEffect';

import QuantitySelector from './QuantitySelector';

export const ItemCardContainer = styled.div`
    padding: 16px;
    background-color: ${({ theme }) => theme.colors.Background};
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
    border-radius: 8px;
`;

export const ProductImage = ShimmerEffect(ProductResolutionImage);

export const OuterWrap = styled.div`
    margin: 0 0 8px;
    padding: 12px;
    background-color: ${({ theme }) => theme.colors.Background};
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
    border-radius: 8px;

    transition-property: transform;
    transition-duration: 350ms;
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);

    &.cartItem-exit,
    &.mixCard-exit {
        transform: translateX(0%);
    }

    &.cartItem-exit-active,
    &.mixCard-exit-active {
        transform: translateX(-200%);
    }

    ${({ theme }) => theme.superQuery.all.and.minWidth.desktopMin.css`
        padding: 16px 16px 8px;
    `};
`;

export const TopWrap = styled.div`
    display: grid;
    grid-template-areas: 'img title title' 'img color del';
    grid-auto-columns: 64px auto 24px;
    grid-gap: 8px;
`;

export const BottomWrap = styled.div`
    display: flex;
    margin-top: 16px;
    padding-top: 8px;
    height: 48px;
    justify-content: space-between;
    border-top: 2px solid ${({ theme }) => theme.colors['Level 1']};
`;

export const Image = styled(ProductImage)`
    grid-area: img;
    margin-right: 8px;
    min-height: 64px;
    height: 64px;
    min-width: 64px;
    width: 64px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: top center;
`;

export const MainDetails = styled.div`
    grid-area: title;
    max-width: 100%;
    display: block;
    overflow: hidden;
`;

export const Name = styled.h3`
    ${({ theme }) => theme.typography.SmallHeadline};
    color: ${({ theme }) => theme.colors.Foreground};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-bottom: 4px;
`;

export const CoreAttribute = styled.p`
    ${({ theme }) => theme.typography.TinyParagraph}
    color: ${({ theme }) => theme.colors['Level 5']};
`;

export const Remove = styled.div`
    grid-area: del;
    align-self: center;
    cursor: pointer;
`;

export const Quantity = styled(QuantitySelector)`
    flex: 1 1 24%;
    justify-content: space-evenly;
`;

export const PriceWrap = styled.div`
    flex: 1 1 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const Price = styled.h3`
    ${({ theme }) => theme.typography.SmallHeadline};
    color: ${({ theme }) => theme.colors.Foreground};
`;

export const Suffix = styled.p`
    ${({ theme }) => theme.typography.TinyParagraph}
    color: ${({ theme }) => theme.colors['Level 5']};
`;
